/* eslint-disable import/prefer-default-export */
// disabled so that this selector keeps the same format as other selectors
export const loading = state =>
  state.loader.get('loading') ||
  state.loader.get('isCaseLoaded') ||
  state.loader.get('isCustomerLoaded') ||
  state.loader.get('isOfferLoaded');
